import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import UserItem from '../components/UserItem';
import { CircularProgress } from '@mui/material';
import { ChevronLeft } from 'lucide-react';

function StalkingList() {
  const { userId } = useParams(); // Get user ID from URL
  const navigate = useNavigate();
  const [stalking, setStalking] = useState([]); // Ensure it's initialized as an empty array
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStalking = async () => {
      try {
        const res = await axiosInstance.get(`/profile/${userId}/stalking`);
        setStalking(res.data || []); // Fallback to empty array
        setLoading(false);
      } catch (err) {
        console.error('Error fetching stalking:', err);
        setLoading(false);
      }
    };

    fetchStalking();
  }, [userId]);

  if (loading) {
    return  (
      <div className="loading-container">
        <CircularProgress size={40} sx={{ color: '#d1d5db' }} />
      </div>
    );
  }

  return (
    <div>
      <div className="top-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <ChevronLeft className="w-8 h-8" />
        </button>
        <h1 className="top-title">Stalking</h1>
      </div>

      <div className="divide-y divide-gray-200 dark:divide-neutral-800 mx-2 mt-2">
        {stalking.length > 0 ? (
          stalking.map((user) => (
            <UserItem key={user.user_id} user={user} navigate={navigate} />
          ))
        ) : (
          <p className="px-4 py-10 text-center text-sm text-gray-500 dark:text-gray-400">No stalking found.</p>
        )}
      </div>
    </div>
  );
}

export default StalkingList;
